import React from 'react';
import ReplyStore from '../../stores/reply';
import { WeaSearchGroup, WeaFormItem, WeaLocaleProvider } from 'ecCom'
import { WeaSwitch } from 'comsMobx';
import { observer } from 'mobx-react';
import { Row, Col, Button } from 'antd';
const getLabel = WeaLocaleProvider.getLabel;
import $ from "jquery";

export interface SearchPanelProps {
    reply: ReplyStore;
    style?: React.CSSProperties;
}

@observer
export default class SearchPanel extends React.Component<SearchPanelProps, any> {
    componentDidMount() {
        this.fiexedWidth();
    }
    componentDidUpdate() {
        this.fiexedWidth();
    }
    fiexedWidth = () => {
        const $content = $(".cube-reply-content");
        $(this.refs._container).width($content.width());

    }
    getSearchs = () => {
        const { reply } = this.props;
        return reply.conditionInfo ? reply.conditionInfo.map((item,i) => {
            return {
                com: (<WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@ybpyih@${i}`}
                    label={item.label}
                    labelCol={{ span: item.labelcol }}
                    error={reply.condition.getError(item)}
                    wrapperCol={{ span: item.fieldcol }}>
                    <WeaSwitch ecId={`${this && this.props && this.props.ecId || ''}_WeaSwitch@wlww93@${i}`} fieldConfig={item} form={reply.condition} />
                </WeaFormItem>),
                colSpan: item.colSpan
            }
        }) : [];
    }
    render() {
        const { reply } = this.props;
        const visibleStyle = { display: `${reply.showSearchDrop ? 'block' : 'none'}` }
        return (
            <div className="cube-search-panel" ref="_container" style={this.props.style}>
                <div className="cube-search-arrow" style={{ right: 110 }} />
                <div className="cube-search-container" style={visibleStyle}>
                    <WeaSearchGroup ecId={`${this && this.props && this.props.ecId || ''}_WeaSearchGroup@z2mwtc`} title={getLabel(20331,"查询条件")} needTigger={true} showGroup={true} items={this.getSearchs()} />
                    <Row ecId={`${this && this.props && this.props.ecId || ''}_Row@5uda88`} style={{ borderTop: '1px solid #dadada', padding: '20px 0' }}>
                        <Col ecId={`${this && this.props && this.props.ecId || ''}_Col@pv9tgo`} span={24} style={{ textAlign: 'center' }}>
                            <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@mpulbo`} type="primary" style={{ marginRight: 15 }} onClick={reply.search}>{getLabel(197,"搜索")}</Button>
                            <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@bq28le`} type="ghost" style={{ marginRight: 15 }} onClick={reply.resetSearch} >{getLabel(2022,"重置")}</Button>
                            <Button ecId={`${this && this.props && this.props.ecId || ''}_Button@2jdhjg`} type="ghost" style={{ marginRight: 15 }} onClick={reply.hideSearch}>{getLabel(201,"取消")}</Button>
                        </Col>
                    </Row>

                </div>
                <div className="cube-search-mask" style={visibleStyle} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/reply/search-panel.tsx